import styles from './FJUsageDetail.module.less';
import FJLocalStore from '../../../../store/FJLocalStore.js';
import FJDropdownNew from '../../../components/FJDropDown/FJDropdownNew.jsx';
import cionNewUrl from '../../../../assets/base64/cion-new.js';
import { useRef, forwardRef, useImperativeHandle } from 'react';

const FJUsageDetailTwo = forwardRef((props, ref) => {
    const { list, renderTrigger, tutalCredit } = props;

    const dropDownRef = useRef(null);

    useImperativeHandle(ref, () => ({
        // 开放给父组件的方法
        closeDropdown: () => {
            dropDownRef.current?.hide();
        },
        openDropdown: () => {
            dropDownRef.current?.show();
        },
    }));

    const _renderOverlay = config => {
        return (
            <div className={styles.detail_box} onClick={e => e.stopPropagation()} ref={config.ref}>
                <div className={styles.title}>{FJLocalStore._('usage-details')}</div>
                {list.map((item, index) => (
                    <ul className={styles.usage_item} key={index}>
                        <li>
                            <div className={styles.label}>{FJLocalStore._(item.label1)}</div>
                            <div className={styles.value}>{item.value1}</div>
                        </li>
                        <li>
                            <div className={styles.label}>{FJLocalStore._(item.label2)}</div>
                            <div className={styles.value}>{item.value2}</div>
                        </li>
                    </ul>
                ))}

                <div className={styles.footer}>
                    <div className={styles.normal_text}>{FJLocalStore._('total')}</div>
                    <div className={styles.credit}>
                        <img src={cionNewUrl} alt='' />
                        <div className={styles.normal_text}>
                            {tutalCredit}
                            {/* &nbsp;
                            {FJLocalStore._('credit')} */}
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <FJDropdownNew
            isTopLayer={true}
            renderTrigger={renderTrigger}
            useAnchorBody
            placement='rightCenter'
            triggerDisplay='flex'
            trigger='hover'
            renderOverlay={_renderOverlay}
            ref={dropDownRef}
        />
    );
});

export default FJUsageDetailTwo;
